import {
  Box,
  FormHelperText,
  MenuItem,
  Select as MUISelect,
} from '@mui/material';
import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { useLocalization } from '../../providers/LocalizationProvider';

const Select = forwardRef(
  // eslint-disable-next-line arrow-body-style
  ({ name, helperText, options, overwriteProps = {}, ...props }, ref) => {
    const { formatMessage } = useLocalization();
    const selectOptions = options.some(option => option.value === '')
      ? options
      : [
          {
            label: formatMessage({
              id: 'PLEASE_SELECT',
              defaultMessage: 'Please Select',
            }),
            value: '',
          },
          ...options,
        ];
    const children = selectOptions.map(option => (
      <MenuItem
        key={option.value}
        value={option?.value}
        disabled={Boolean(option.disabled)}>
        {option.label}
      </MenuItem>
    ));

    return (
      <Box sx={{ mt: '-5px' }}>
        <Controller
          defaultValue=""
          name={name}
          render={({ field, fieldState: { error: fsError } }) => {
            // the placeholder MenuItem is value '', so only that (or no value
            // at all) is a placeholder. A real option of 0 or false is not.
            const isPlaceholder =
              field?.value === '' ||
              field?.value === null ||
              field?.value === undefined;
            return (
              <Box>
                <MUISelect
                  displayEmpty
                  defaultValue=""
                  size="small"
                  fullWidth
                  value={field?.value ?? ''}
                  {...field}
                  {...props}
                  error={Boolean(fsError?.message)}
                  ref={ref}
                  inputProps={{}}
                  {...overwriteProps}
                  sx={[
                    // "Please select" is a real MenuItem, not a placeholder
                    // attribute, so match MUI's ::placeholder treatment.
                    isPlaceholder && {
                      '& .MuiSelect-select': {
                        opacity: theme =>
                          theme.palette.mode === 'light' ? 0.42 : 0.5,
                      },
                    },
                    // props then overwriteProps, so sx precedence matches the
                    // spread order above where overwriteProps wins.
                    ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
                    ...(Array.isArray(overwriteProps.sx)
                      ? overwriteProps.sx
                      : [overwriteProps.sx]),
                  ].filter(Boolean)}>
                  {children}
                </MUISelect>
                {fsError || helperText ? (
                  <FormHelperText
                    sx={{ typography: 'body2' }}
                    error={Boolean(fsError)}>
                    {fsError?.message || helperText}
                  </FormHelperText>
                ) : null}
              </Box>
            );
          }}
        />
      </Box>
    );
  },
);

export default Select;
